import React from 'react'
import styles from './Header.module.css'
import { HeaderProps } from './types'

const Header = ({ id, dataViewLabel }: HeaderProps) => {
    return (
        <header id={id} className={styles.header} data-view-label={dataViewLabel}>
            <img src={'/pages/logo/logo.png'} className={styles.logo} alt='foodslabo-logo' />
        </header>
    )
}

export default Header
